var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 320 320"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 176",
  d: "M272.417 144.678L256.8 82.225a20.928 20.928 0 00-15.028-15.028l-62.449-15.613a20.792 20.792 0 00-19.711 5.464L48.074 168.586a20.673 20.673 0 000 29.275l78.066 78.066a20.673 20.673 0 0029.275 0L266.953 164.39a20.792 20.792 0 005.464-19.712zm-77.969-15.126a20.7 20.7 0 1129.275 0 20.673 20.673 0 01-29.275 0z",
  fill: "#ed6c7b"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 177",
  d: "M266.95 164.389L155.415 275.926a20.673 20.673 0 01-29.275 0l-39.033-39.033L194.45 129.552a20.7 20.7 0 0029.275-29.275l27.616-27.616a20.861 20.861 0 015.464 9.564l15.613 62.453a20.79 20.79 0 01-5.468 19.711z",
  fill: "#d65b72"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 178",
  d: "M126.136 158.827a20.7 20.7 0 1129.275 0 20.724 20.724 0 01-29.275 0zm19.516-19.517a6.9 6.9 0 100 9.758 6.9 6.9 0 00.005-9.758z",
  fill: "#ffe478"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 179",
  d: "M135.899 227.135a20.7 20.7 0 1129.275 0 20.724 20.724 0 01-29.275 0zm19.516-19.516a6.9 6.9 0 100 9.758 6.9 6.9 0 000-9.758z",
  fill: "#ffca36"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 180",
  d: "M190.35 180.291l-52.5 5.855-35.325 3.9a6.6 6.6 0 01-5.66-1.952 7.044 7.044 0 01-1.952-4.1 6.839 6.839 0 016.05-7.612l52.5-5.855 35.325-3.9a6.876 6.876 0 011.562 13.664z",
  fill: "#ffe478"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 181",
  d: "M190.35 180.291l-52.5 5.855 15.613-15.613 35.325-3.9a6.876 6.876 0 111.561 13.662z",
  fill: "#ffca36"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 182",
  d: "M275.475 58.284l-51.752 51.752a6.9 6.9 0 01-9.758-9.758l51.752-51.753a6.833 6.833 0 019.758 0 6.833 6.833 0 010 9.759z",
  fill: "#3e5959"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 183",
  d: "M213.965 110.036l61.511-61.511a6.833 6.833 0 010 9.758l-51.752 51.753a6.833 6.833 0 01-9.759 0z",
  fill: "#384949"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 8",
  fill: "none",
  d: "M0 0h320v320H0z"
})));
export default SvgDiscount;